import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            快速导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            主题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按专区快速定位你感兴趣的漫画内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexData.map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              className="flex flex-col items-center gap-3 p-5 bg-background-100 rounded-2xl transition-all duration-300 hover:-translate-y-1 hover:bg-primary-50 cursor-pointer no-underline"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                {item.title}
              </span>
              <span className="text-xs text-foreground-400">
                {item.description}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}